module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope"
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Liberação")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Liberação Proposta',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), ((!_vm._.isEmpty(this.restricoesAtivasEntidade) || !_vm._.isEmpty(this.restricoesAtivasProjetosDaEntidade))) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible",
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((this.restricoesAtivasEntidade), function(restricaoEntidade) {
    return _c('p', [_vm._v("\n              " + _vm._s(restricaoEntidade.codoco) + " - " + _vm._s(restricaoEntidade.desroc) + "\n            ")])
  }), _vm._v(" "), _vm._l((this.restricoesAtivasProjetosDaEntidade), function(restricaoProjeto) {
    return _c('p', [_vm._v("\n              " + _vm._s(restricaoProjeto.codoco) + " - " + _vm._s(restricaoProjeto.desroc) + "\n            ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal col-md-12",
    attrs: {
      "name": "frmProposalReleaseRegister",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('fieldset', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('dl', {}, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
    staticClass: "ng-binding"
  }, [_c('font', {
    staticStyle: {
      "color": "dimgrey"
    }
  }, [_vm._v(" Nome: " + _vm._s(_vm.preProposta.entidade.ds_nome))])], 1), _vm._v(" "), _c('dd', {
    staticClass: "ng-binding"
  }, [_c('font', {
    staticStyle: {
      "color": "dimgrey"
    }
  }, [_vm._v("  CNPJ: " + _vm._s(_vm._f("cnpj")(_vm.preProposta.entidade.ds_cnpj)))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('titulo da proposta')
    },
    attrs: {
      "uib-tooltip": "Título da proposta"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "titulo da proposta"
    }
  }, [_vm._v(" Título da proposta: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preProposta.ds_nome),
      expression: "preProposta.ds_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:150'),
      expression: "'required|max:150'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "titulo da proposta",
      "data-vv-as": "Título da proposta",
      "maxlength": "150",
      "id": "titulo da proposta",
      "type": "text"
    },
    domProps: {
      "value": (_vm.preProposta.ds_nome)
    },
    on: {
      "keypress": _vm.retiraAspas,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preProposta, "ds_nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('titulo da proposta')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('titulo da proposta')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('documentos')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" Documentos anexos obrigatórios: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.tipoDocumentos,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um documento",
      "label": "ds_tipo",
      "track-by": "ds_tipo",
      "preselect-first": true,
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "selectedLabel": "Selecionado",
      "name": "documentos",
      "data-vv-as": "Documentos anexos obrigatórios"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option.type))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }]),
    model: {
      value: (_vm.preProposta.tipo_documentos),
      callback: function($$v) {
        _vm.$set(_vm.preProposta, "tipo_documentos", $$v)
      },
      expression: "preProposta.tipo_documentos"
    }
  }, [_vm._v(" "), _c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('documentos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('documentos')))]) : _vm._e()]), _vm._v(" "), (_vm.preProposta.dc_investimento <= 300000) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" Ref. Processo Simplificado: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preProposta.simplificado),
      expression: "preProposta.simplificado"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.preProposta.simplificado) ? _vm._i(_vm.preProposta.simplificado, null) > -1 : (_vm.preProposta.simplificado)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.preProposta.simplificado,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.preProposta, "simplificado", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.preProposta, "simplificado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.preProposta, "simplificado", $$c)
        }
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('investimento previsto')
    },
    attrs: {
      "uib-tooltip": "Investimento previsto"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "investimento previsto"
    }
  }, [_vm._v(" Investimento previsto: ")]), _vm._v(" "), _c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20|between:0.01,9999999999999'),
      expression: "'required|max:20|between:0.01,9999999999999'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "investimento previsto",
      "id": "investimento previsto",
      "data-vv-as": "Investimento previsto",
      "maxlength": "20",
      "type": "text"
    },
    model: {
      value: (_vm.preProposta.dc_investimento),
      callback: function($$v) {
        _vm.$set(_vm.preProposta, "dc_investimento", $$v)
      },
      expression: "preProposta.dc_investimento"
    }
  }), _vm._v(" "), (_vm.errors.first('investimento previsto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s('o campo Investimento Previsto está com valor zerado ou incorreto.'))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('mensagem')
    },
    attrs: {
      "uib-tooltip": "Mensagem a ser encaminhada para as entidades"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "mensagem"
    }
  }, [_vm._v(" Mensagem a ser encaminhada para as entidades: ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preProposta.ds_mensagem_entidades),
      expression: "preProposta.ds_mensagem_entidades"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": "Mensagem a ser encaminhada",
      "name": "mensagem",
      "id": "mensagem",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.preProposta.ds_mensagem_entidades)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preProposta, "ds_mensagem_entidades", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('mensagem')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('mensagem')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [((_vm._.isEmpty(this.restricoesAtivasEntidade) && _vm._.isEmpty(this.restricoesAtivasProjetosDaEntidade))) ? _c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.concluir($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Liberação da Proposta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Alerta!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("A Entidade possui restrições que impedem a liberação da proposta.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6740ae5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/proposta/Liberacao.vue
// module id = 1995
// module chunks = 1